export default __webpack_public_path__ + "static/media/Ntorq125Racing_LateralDer.efd6a892.webp";